import GridBarFiltersAtomInputRange, { InputFieldFormat } from "@/components/Grid/Bar/Filters/Atom/InputRange";
import React, { useCallback } from "react";

import { SupSlider } from "@repo/core-ui";

interface GridBarFiltersAtomRangeProps {
  max: number;
  from: number;
  to: number;
  min: number;
  onChange?: (from: number, to: number) => void;
  step?: number;
  formatter?: (value: number) => React.ReactNode;
  noInputs?: boolean;
  fieldType?: InputFieldFormat;
}

export default function GridBarFiltersAtomRange({ from, to, step, min, max, onChange, formatter, noInputs, fieldType = "decimal" }: GridBarFiltersAtomRangeProps) {
  const handleInputChange = useCallback(
    (value: number | number[]) => {
      if (Array.isArray(value)) {
        onChange?.(value[0], value[1]);
      }
    },
    [onChange]
  );
  return (
    <div className="mt-2 flex flex-col justify-center">
      {!noInputs && <GridBarFiltersAtomInputRange type={fieldType} from={from} to={to} min={min} max={max} onChange={onChange} />}
      <SupSlider
        formatDisplayValue={formatter}
        grabberType="value"
        value={[from, to]}
        className="w-full"
        max={max}
        min={min}
        step={step}
        marks={false}
        displayMaxButton={false}
        pushable
        onAfterChange={handleInputChange}
      />
    </div>
  );
}
